// Port of src/app/components/nav-bar/logo/logo.component.{ts,html}
// (mypart-logo). The Angular .scss file was empty — no stylesheet.
//
// NgOptimizedImage [fill] is replicated with the inline style it applies
// (position: absolute; inset: 0; width: 100%; height: 100%).

import type { CSSProperties } from 'react';

export interface LogoProps {
  showBigSearchHomePage: boolean | undefined;
  appTheme: 'dark' | 'light';
  onGoBackToHomePage: () => void;
  onOpenMenuDropdown: (menu: HTMLButtonElement) => void;
}

const fillStyle: CSSProperties = {
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%'
};

export default function Logo({
  showBigSearchHomePage,
  appTheme,
  onGoBackToHomePage,
  onOpenMenuDropdown
}: LogoProps) {
  return (
    <div className={`flex flex-col items-baseline md:items-center lg:-mt-[25px] mb-0 ml-[-.5rem] md:ml-[0rem]${showBigSearchHomePage ? ' !mt-0' : ''}`}>
      <section className="flex items-center sm:ml-[25px] md:ml-0">
        <button
          onClick={(e) => onOpenMenuDropdown(e.currentTarget)}
          aria-controls="menu"
          aria-expanded="false"
          className={`inline-flex items-baseline md:w-10 h-10 justify-center text-sm text-gray-500 rounded-lg
            hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-white
            dark:hover:bg-gray-700 dark:focus:ring-gray-600${showBigSearchHomePage ? ' !text-white' : ''}`}
          type="button">
          <span className="sr-only">Open main menu</span>
          <svg aria-hidden="true" className="w-6 h-6" fill="none" viewBox="0 0 17 14" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1h15M1 7h15M1 13h15" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                  strokeWidth="2" />
          </svg>
        </button>

        <a onClick={onGoBackToHomePage} className="flex w-[170px] h-[54px] mt-[2px] relative items-center logo-container
                !mb-[2px] !sm:mb-1 cursor-pointer">
          {appTheme === 'dark' || showBigSearchHomePage ? (
            <img alt="Songhunt Dark Logo" className="mr-3" src="/assets/nav_bar/logo_dark.png"
                 style={fillStyle} fetchPriority="high" />
          ) : (
            <img alt="Songhunt Light Logo" className="mr-3" src="/assets/nav_bar/logo_light.png"
                 style={fillStyle} fetchPriority="high" />
          )}
        </a>
      </section>
    </div>
  );
}
